import { Component, EventEmitter, Output } from '@angular/core';

import { fadeAnimation } from '../../../modules/children-portfolio/constants/animations';

@Component({
  selector: 'app-reset-filter',
  templateUrl: './reset-filter.component.html',
  styleUrls: ['./reset-filter.component.scss'],
  animations: [fadeAnimation],
  standalone: false,
})
export class ResetFilterComponent {
  @Output() resetFilters = new EventEmitter<void>();

  onResetClick() {
    this.resetFilters.emit();
  }
}
